function getLocalStorage(): Storage {
    if (canAccessLocalStorage()) {
        return window.localStorage;
    }
    return {
        getItem: (key: string) => null,
        setItem: (key: string, value: string) => undefined,
        clear: () => null,
        removeItem: (key: string) => null,
        key: (index: number) => null,
        length: 0,
    };
}

export function canAccessLocalStorage(): boolean {
    try {
        localStorage.setItem('browserFeature.localStorageAccess', '1');
        const data = localStorage.getItem('browserFeature.localStorageAccess');
        return data === '1';
    } catch {
        return false;
    }
}

export const localStorage = getLocalStorage();
